import { Plus } from 'lucide-react';
import { useState } from 'react';

import { CreateModelForm } from './CreateModelForm';
import { ModelsFilter, ModelsFilterValue } from './ModelsFilter';
import { ModelsTable } from './ModelsTable';
import { RemoveModelDialog } from './RemoveModel';
import { UpdateModelForm } from './UpdateModelForm';

import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { FilterModelsDto, Model } from '@/services/ModelsService';

export function ModelsPage() {
  const [filter, setFilter] = useState<ModelsFilterValue>({});

  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const [selectedModel, setSelectedModel] = useState<Model | null>(null);

  function handleEdit(model: Model) {
    setSelectedModel(model);
    setOpenEdit(true);
  }

  function handleRemove(model: Model) {
    setSelectedModel(model);
    setOpenRemove(true);
  }

  const filtersForQuery: FilterModelsDto = {
    promptName: filter.promptName,
    serviceName: filter.serviceName,
  };

  return (
    <div className="container mx-auto py-4">
      <div className="mb-6 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Models</h2>
          <p className="mt-1 text-gray-600">Manage registered models</p>
        </div>
        <Button className="gap-2" onClick={() => setOpenCreate(true)}>
          <Plus className="h-4 w-4" />
          Add New Model
        </Button>
      </div>
      <Card className="mb-6">
        <CardContent className="p-4">
          <ModelsFilter onFilterChange={setFilter} filter={filter} />
        </CardContent>
      </Card>
      <ModelsTable
        filter={filtersForQuery}
        onEdit={handleEdit}
        onRemove={handleRemove}
      />

      <CreateModelForm
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        onSuccess={() => {}}
        filter={filtersForQuery}
      />
      <UpdateModelForm
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        model={selectedModel}
        onSuccess={() => {}}
        filter={filtersForQuery}
      />
      {selectedModel && (
        <RemoveModelDialog
          open={openRemove}
          onClose={() => setOpenRemove(false)}
          model={selectedModel}
          filter={filtersForQuery}
        />
      )}
    </div>
  );
}

export default ModelsPage;
